import { mcn } from "@/utils/mergeClassNames";
import { Disclosure, Tab } from "@headlessui/react";
import { useState } from "react";
import { Markdown } from "../Markdown";
import { Section, SectionContainer, SectionProps } from "./Sections";
import { IconActionChevronDown } from "@/components/Icons";

type Tab = {
  title: string;
  markdownContent: string | undefined | null;
  sectionProps?: SectionProps;
};

type Props = {
  sectionId?: string;
  tabs: Tab[];
  defaultTabIndex?: number;
};

export const InformationTextTabSection = (props: Props) => {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

  return (
    <>
      <Section className="bg-light-yellow" id={props.sectionId}>
        <SectionContainer>
          <h2 className="text-style-headline2 tablet:text-center mb-xl">
            Information
          </h2>
          <div className="tablet-sm:hidden">
            {props.tabs.map((tab, index) => (
              <div className="mt-md" key={index}>
                <Disclosure key={index} defaultOpen={false}>
                  {({ open }) => (
                    <>
                      {index !== 0 && (
                        <span className="flex w-full h-[1px] bg-blue mb-md" />
                      )}
                      <Disclosure.Button
                        className={mcn(
                          "flex justify-between items-center w-full"
                        )}
                      >
                        <h3
                          className={mcn(
                            "text-style-primary",
                            open && "font-bold"
                          )}
                        >
                          {tab.title}
                        </h3>
                        <IconActionChevronDown
                          className={mcn("w-lg h-lg", open && "rotate-180")}
                        />
                      </Disclosure.Button>
                      <Disclosure.Panel>
                        <Markdown
                          className="columns-1 mt-sm tablet-lg:columns-2 gap-default"
                          content={tab.markdownContent ?? ""}
                        />
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>
              </div>
            ))}
          </div>
          <div className="hidden tablet-sm:flex flex-col">
            {props.tabs.map((tab, idx) => (
              <div
                key={tab.title ?? idx}
                className={mcn(
                  "border border-black rounded px-md py-xs",
                  idx !== props.tabs.length - 1 && "border-b-0"
                )}
              >
                <button
                  className="w-full flex justify-between items-center text-style-primary py-xs"
                  onClick={() =>
                    setSelectedIndex(selectedIndex === idx ? null : idx)
                  }
                  aria-expanded={selectedIndex === idx}
                >
                  <span className="font-semibold">{tab.title}</span>
                  <IconActionChevronDown
                    className={mcn(
                      "w-lg h-lg transition-transform",
                      selectedIndex === idx && "rotate-180"
                    )}
                  />
                </button>
                {selectedIndex === idx && (
                  <div className="pt-md">
                    <Markdown
                      className="columns-1 tablet-lg:columns-2 gap-default"
                      content={tab.markdownContent ?? ""}
                    />
                  </div>
                )}
              </div>
            ))}
          </div>
        </SectionContainer>
      </Section>
    </>
  );
};
